module.exports = __webpack_public_path__ + "img/mount5.a3f97840.jpg";